import { connect } from 'react-redux';
import { diagramSelectors } from '../../../redux/diagram/slice';
import { RootState } from '../../../redux/store';
import { EditHeader } from '../EditHeader';

type EditHeaderOwnProps = {
  title: string;
};

const mapStateToProps = (state: RootState, ownProps: EditHeaderOwnProps) => ({
  ...ownProps,
  exportingTitle: diagramSelectors.getExportingTitle(state),
  isExporting: diagramSelectors.getIsExporting(state),
});

export type EditHeaderProps = Partial<ReturnType<typeof mapStateToProps>>;

export const EditHeaderContainer = connect(mapStateToProps)(EditHeader);
